import { omitBy } from 'lodash';

import adjustUrlParams from './adjustUrlParams';
import isEmptyString from './utils/isEmptyString';

import { Params } from './types';

const sanitize = (params: Params, onlyTruthyParams: boolean) =>
  onlyTruthyParams ? omitBy(params, isEmptyString) : params;

/**
 * Takes an object and adds it as a query string to the given URL.
 * If there is already a query string with the URL, append the given
 * params to the query string.
 *
 * Optionally, filters out falsy params with `onlyTruthParams`
 */
const addParamsToUrl = (
  url: string = '',
  params = {},
  onlyTruthyParams = false
) =>
  adjustUrlParams(
    currentParams => ({
      ...currentParams,
      ...sanitize(params, onlyTruthyParams),
    }),
    url
  );

export default addParamsToUrl;
